import MarketplacesSelection from './MarketplacesSelection.vue';

export default MarketplacesSelection;
